import React, { useEffect, useState, useRef } from 'react';
import locale from 'antd/es/date-picker/locale/en_GB';
import TimeInput2 from '../../ui/time-input2/TimeInput2';
import { InputWrapper, InputHeadingWrapper, InputFieldWrapper } from '../EventInput.styles';
import OdfjellDatePicker from '../../common/date-picker/OdfjellDatePicker';
import { getDateFromFormat, getDateNow, getLuxonDateTime } from 'odfjell-date-time-utils/dateTimeUtils';
import { DateTimeFormat, formatDateTime } from 'odfjell-date-time-utils/dateTimeFormatter';

type Props = {
    onChange: (datetime: Date) => void;
    initialValue: Date | null;
};

const EventDatetimeInputComponent: React.FC<Props> = (props) => {
    const inputDateTimeFormat = 'MM.dd.yyyy HH:mm';
    const [inputDate, setInputDate] = useState<Date | null>(null);
    const [inputTime, setInputTime] = useState('');
    const [inputDatetime, setInputDatetime] = useState(props.initialValue ? props.initialValue : new Date());
    const timeInputRef = useRef<any>(null);

    const onChangeDate = (dateFromPicker: Date) => {
        setInputDate({ ...dateFromPicker });
        const date = getDateFromFormat(formatDateTime(dateFromPicker, DateTimeFormat.otherFormats.dateOnly) + ' ' + inputTime, inputDateTimeFormat);

        setInputDatetime(date);
        props.onChange(date);

        // Auto-focus the time input after date selection
        if (timeInputRef.current?.inputRef?.current) {
            setTimeout(() => {
                timeInputRef.current.inputRef.current.focus();
                timeInputRef.current.inputRef.current.select();
            }, 0);
        }
    };

    const onChangeTime = (timeString) => {
        setInputTime(timeString);

        const date = getDateFromFormat(formatDateTime(inputDate, DateTimeFormat.otherFormats.dateOnly) + ' ' + timeString, inputDateTimeFormat);

        setInputDatetime(date);
        props.onChange(date);
    };

    useEffect(() => {
        if (props.initialValue) {
            setInputDatetime(props.initialValue);
            setInputDate(props.initialValue);
            setInputTime(formatDateTime(props.initialValue, DateTimeFormat.timeFormats.timeOnly));
        } else {
            setInputDatetime(getDateNow());
            setInputDate(getDateNow());
            setInputTime(formatDateTime(getDateNow(), DateTimeFormat.timeFormats.timeOnly));
        }
    }, [props.initialValue]);

    return (
        <>
            <InputWrapper>
                <InputHeadingWrapper>Event Date</InputHeadingWrapper>
                <InputFieldWrapper>
                    <OdfjellDatePicker
                        className="date-picker"
                        format={'dd.MM.yyyy'}
                        clearIcon={false}
                        value={getLuxonDateTime(inputDatetime)}
                        defaultValue={getLuxonDateTime(inputDatetime)}
                        placeholder={''}
                        onChange={(e) => onChangeDate(e.toJSDate())}
                        locale={locale}
                    />
                    <TimeInput2
                        ref={timeInputRef}
                        className="time-picker"
                        onChange={onChangeTime}
                        value={formatDateTime(inputDatetime, DateTimeFormat.timeFormats.timeOnly)}
                    />
                </InputFieldWrapper>
            </InputWrapper>
        </>
    );
};

export default EventDatetimeInputComponent;
